module.exports = __webpack_public_path__ + "img/teppich.d7e582c2.png";